var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"controller-close",class:_vm.getThemeClass,on:{"click":_vm.close}},[_c('icon',{staticClass:"controller-close__icon",attrs:{"name":"close"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }